import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import DetailsAndEvents from './DetailsAndEvents';
import GeneralInfo from './GeneralInfo';

const StyledContainerBox = styled(Box)(() => ({
  minHeight: 'calc(100vh - 5.5rem)'
}));
const StyledContainerGrid = styled(Grid)(() => ({
  marginTop: '0 ',
  padding: '1rem 0 0 0',
  textAlign: 'left',
  '& ::-webkit-scrollbar': {
    width: '0.4em '
  }
}));

const MyProfile = () => {
  return (
    <>
      <StyledContainerBox>
        <StyledContainerGrid container spacing={1}>
          <Grid item lg={2} xs={1} />
          <Grid container lg={8} xs={10} spacing={2} item>
            <Grid item lg={3} xs={12}>
              <GeneralInfo />
            </Grid>

            <Grid item lg={9} xs={12}>
              <DetailsAndEvents />
            </Grid>
          </Grid>

          <Grid item lg={2} xs={1} />
        </StyledContainerGrid>
      </StyledContainerBox>
    </>
  );
};
export default MyProfile;
